(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lfCountdownBound) return;
  window.__lfCountdownBound = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n) {
    return String(n < 0 ? 0 : n).padStart(2, '0');
  }

  function init(root) {
    if (root.dataset.lfReady === 'true') return;
    root.dataset.lfReady = 'true';

    var hours = parseInt(root.getAttribute('data-hours'), 10);
    var minutes = parseInt(root.getAttribute('data-minutes'), 10);
    hours = isNaN(hours) ? 1 : Math.min(23, Math.max(0, hours));
    minutes = isNaN(minutes) ? 59 : Math.min(59, Math.max(0, minutes));

    var out = {
      days: root.querySelector('[data-lf-cd="days"]'),
      hours: root.querySelector('[data-lf-cd="hours"]'),
      minutes: root.querySelector('[data-lf-cd="minutes"]'),
      seconds: root.querySelector('[data-lf-cd="seconds"]')
    };
    if (!out.seconds) return;

    var total = hours * 3600 + minutes * 60 + 59;

    function render(remaining) {
      if (out.days) out.days.textContent = pad(Math.floor(remaining / 86400));
      if (out.hours) out.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
      if (out.minutes) out.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      if (out.seconds) out.seconds.textContent = pad(remaining % 60);
    }

    render(total);

    // Reduced motion: show the starting time and never tick.
    if (reduced && reduced.matches) return;

    var endsAt = Date.now() + total * 1000;
    var timer = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(timer);
        return;
      }
      var left = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
      render(left);
      if (left <= 0) window.clearInterval(timer);
    }, 1000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lf-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-lf-fp]');
  if (!root) return;
  var dataEl = document.querySelector('[data-lf-variant-data]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var cfg = window.LF_FP || { designIndex: 0, packIndex: 1, moneyFormat: '\u20ac__AMOUNT__' };
  var designSelects = Array.prototype.slice.call(root.querySelectorAll('[data-lf-design-select]'));
  var designRows = Array.prototype.slice.call(root.querySelectorAll('[data-lf-design-row]'));
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-lf-tier]'));
  var addonInputs = Array.prototype.slice.call(root.querySelectorAll('[data-lf-addon]'));
  var mainImage = root.querySelector('[data-lf-main-image]');
  var msg = root.querySelector('[data-lf-msg]');
  var scarcity = root.querySelector('[data-lf-scarcity]');
  var scarcityText = root.querySelector('[data-lf-scarcity-text]');
  var state = { pack: tiers.length ? tiers[0].dataset.pack : null };

  function packSize() {
    var t = tiers.filter(function (x) { return x.dataset.pack === state.pack; })[0];
    if (!t) return 1;
    var n = parseInt(t.dataset.packSize, 10);
    if (isNaN(n) || n < 1) n = 1;
    return Math.min(n, designSelects.length || 1);
  }

  function selectedDesigns() {
    return designSelects.slice(0, packSize()).map(function (s) { return s.value; });
  }

  // srcset outranks src: drop it whenever we swap the gallery image directly
  function setImage(src) {
    if (!mainImage || !src) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = src;
  }

  function money(cents) {
    var fmt = cfg.moneyFormat || '\u20ac__AMOUNT__';
    var value = (cents / 100).toFixed(2);
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
    return out.replace(/\s+/g, ' ').trim();
  }

  function findVariant() {
    var design = selectedDesigns()[0];
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options;
      if (o[cfg.designIndex] === design && o[cfg.packIndex] === state.pack) return variants[i];
    }
    return null;
  }

  function render() {
    var v = findVariant();
    var n = packSize();
    designRows.forEach(function (row) {
      var idx = parseInt(row.dataset.index, 10);
      var show = idx <= n;
      row.hidden = !show;
      if (!show) return;
      var sel = designSelects[idx - 1];
      var img = row.querySelector('[data-lf-design-thumb] img');
      if (!sel || !img) return;
      var opt = sel.options[sel.selectedIndex];
      var src = opt && opt.getAttribute('data-image');
      if (src) {
        img.src = src;
        img.hidden = false;
      }
    });
    tiers.forEach(function (t) {
      var on = t.dataset.pack === state.pack;
      t.classList.toggle('lf-tier--selected', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      var priceEl = t.querySelector('[data-lf-price]');
      if (priceEl && v && on) priceEl.textContent = money(v.price);
    });
    // image swaps are driven by the design dropdown, the thumbnails and the ?variant deep link only —
    // never by render(), so the product's lead media always survives first paint
    if (v && v.image && state.__deepLink) {
      setImage(v.image);
      state.__deepLink = false;
    }
    if (scarcity) {
      var count = (v && v.inventory > 0) ? v.inventory : (cfg.fallbackCount || 0);
      if (cfg.showScarcity && v && v.available && count > 0 && count <= 60) {
        scarcity.hidden = false;
        if (scarcityText) scarcityText.textContent = (cfg.scarcityTemplate || '').replace('__COUNT__', count);
      } else {
        scarcity.hidden = true;
      }
    }
    var addBtn = root.querySelector('[data-lf-add]');
    var buyNowBtn = root.querySelector('[data-lf-buy-now]');
    var soldOut = !!(v && !v.available);
    [addBtn, buyNowBtn].forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    });
    if (v) {
      // only mirror the variant into the URL on the product template — writing ?variant= on the
      // funnel homepage makes Shopify lead with that variant's image on the next load
      if (cfg.isProductPage === 'product') {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }
    }
    return v;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-lf-cart-count]');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  function cartItems(v) {
    var designs = selectedDesigns();
    var props = {};
    designs.forEach(function (d, i) { props['Mask ' + (i + 1)] = d; });
    var items = [{ id: v.id, quantity: 1, properties: props }];
    addonInputs.forEach(function (input) {
      if (!input.checked) return;
      var addonId = Number(input.getAttribute('data-variant'));
      if (addonId) items.push({ id: addonId, quantity: 1 });
    });
    return items;
  }

  function add(goToCheckout) {
    var v = render();
    if (!v) { if (msg) msg.textContent = 'Unavailable'; return; }
    if (!v.available) { if (msg) msg.textContent = 'Sold out'; return; }
    if (msg) msg.textContent = '\u2026';
    post('/cart/add.js', { items: cartItems(v) })
      .then(function (res) {
        if (!res.ok) { msg.textContent = (res.body && res.body.description) || 'Could not add to cart.'; return; }
        refreshCount();
        if (goToCheckout) { window.location.href = '/checkout'; return; }
        if (msg) msg.textContent = 'Added to cart';
      })
      .catch(function () { if (msg) msg.textContent = 'Could not add to cart.'; });
  }

  designSelects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.getAttribute('data-image')) setImage(opt.getAttribute('data-image'));
      if (msg) msg.textContent = '';
      render();
    });
  });

  tiers.forEach(function (t) {
    t.addEventListener('click', function () {
      state.pack = t.dataset.pack;
      if (msg) msg.textContent = '';
      render();
    });
  });

  var addBtn = root.querySelector('[data-lf-add]');
  var buyBtn = root.querySelector('[data-lf-buy-now]');
  if (addBtn) addBtn.addEventListener('click', function () { add(false); });
  if (buyBtn) buyBtn.addEventListener('click', function () { add(true); });

  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lf-thumb]'));
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (b.dataset.src) setImage(b.dataset.src);
    });
  });
  var prev = root.querySelector('[data-lf-thumb-prev]');
  var next = root.querySelector('[data-lf-thumb-next]');
  function step(dir) {
    if (!thumbs.length) return;
    var i = thumbs.findIndex(function (x) { return x.classList.contains('is-active'); });
    i = (i + dir + thumbs.length) % thumbs.length;
    thumbs[i].click();
  }
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });

  render();

  // deep link support: /products/ski-mask?variant=<id>
  (function () {
    var wanted = Number(new URLSearchParams(window.location.search).get('variant'));
    if (!wanted) return;
    var match = variants.filter(function (x) { return x.id === wanted; })[0];
    if (!match) return;
    state.pack = match.options[cfg.packIndex];
    var matchedDesign = match.options[cfg.designIndex];
    if (matchedDesign) {
      designSelects.forEach(function (sel) { sel.value = matchedDesign; });
    }
    state.__deepLink = true;
    render();
  })();

  // keyboard support for the tier radiogroup
  if (tiers.length) {
    tiers.forEach(function (t, i) {
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        var next = tiers[(i + dir + tiers.length) % tiers.length];
        next.focus();
        next.click();
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var buttons = document.querySelectorAll('[data-lf-mq-toggle]');
  Array.prototype.forEach.call(buttons, function (btn) {
    var mq = btn.closest('.lf-marquee');
    if (!mq) return;
    btn.addEventListener('click', function () {
      var paused = mq.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var label = paused ? btn.getAttribute('data-play-label') : btn.getAttribute('data-pause-label');
      if (label) btn.setAttribute('aria-label', label);
      var glyph = btn.querySelector('.lf-icon');
      if (glyph) glyph.textContent = paused ? 'play_arrow' : 'pause';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
